import { strings } from "res";
import { DashboardIcon, OrderIcon, ReportIcon } from "../assets/svg/icon";
import {
  UserOutlined,
  TagOutlined,
  BranchesOutlined,
  FileOutlined,
  MessageFilled
} from "@ant-design/icons";

const dashBoardNavTree = [
  {
    key: "Home",
    path: strings.navigation.path.dashboard,
    title: "Home",
    breadcrumb: false,
    submenu: [
      {
        key: "Dashboard",
        path: strings.navigation.path.dashboard,
        title: "Dashboard",
        icon: DashboardIcon,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Contents",
        path: strings.navigation.path.contents,
        title: "Berita",
        icon: ReportIcon,
        breadcrumb: false,
        submenu: [
          {
            key: "Headlines",
            path: strings.navigation.path.contents,
            title: "Headlines",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Berita Harian",
            path: strings.navigation.path.contents,
            title: "Berita Harian",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Pendidikan",
            path: strings.navigation.path.contents,
            title: "Pendidikan",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Populer",
            path: strings.navigation.path.contents,
            title: "Populer",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Politik",
            path: strings.navigation.path.contents,
            title: "Politik",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Teknologi",
            path: strings.navigation.path.contents,
            title: "Teknologi",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Olahraga",
            path: strings.navigation.path.contents,
            title: "Olahraga",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "Kesehatan",
            path: strings.navigation.path.contents,
            title: "Kesehatan",
            // icon: ReportIcon,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "Categories",
        path: strings.navigation.path.categories,
        title: "Categories",
        icon: OrderIcon,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Subcategories",
        path: strings.navigation.path.subcategories,
        title: "Subcategories",
        icon: BranchesOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Tags",
        path: strings.navigation.path.tags,
        title: "Tags",
        icon: TagOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Users",
        path: strings.navigation.path.users,
        title: "Users",
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      }
    ],
  },
];

// const ControlTree = [{
//   key: "Pengaturan",
//   path: strings.navigation.path.settings,
//   title: "Pengaturan",
//   breadcrumb: false,
//   submenu: [
//     {
//       key: "Pengaturan",
//       path: strings.navigation.path.settings,
//       title: "Pengaturan",
//       icon: SettingIcon,
//       breadcrumb: false,
//       submenu: []
//     }
//   ]
// }]

const navigationConfig = [
  ...dashBoardNavTree,
  // ...ControlTree,
];

export default navigationConfig;
